import { render, staticRenderFns } from "./modFreqs.vue?vue&type=template&id=61de88e6&scoped=true&"
import script from "./modFreqs.vue?vue&type=script&lang=js&"
export * from "./modFreqs.vue?vue&type=script&lang=js&"
import style0 from "./modFreqs.vue?vue&type=style&index=0&id=61de88e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de88e6",
  null
  
)

export default component.exports